// Activity-log (eseménynapló) feature — query-kulcs gyár + a lista-szűrő típusa. A tényleges hívásokat a
// route a tipizált ts-rest kliensen (`api.activityLog.*`) intézi; a kulcsok itt élnek (cache-egységesítés).
// A `@atlas/contracts` a szerződés forrás-igazsága — itt csak kulcs-logika van (a tickets mintára).
// A lapozás KEYSET-cursor (nem offset): a szerver `nextCursor`-t ad, a lista-cache a szűrőkre van címezve
// (szűrő-váltás új cache-bejegyzést nyit → automatikus lapozás-reset).

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-váltás új cache-bejegyzést nyit).
 *  A `q` az EGYSÉGES szabad-szöveg (művelet + entitás + tenant + szereplő név/e-mail — a szerver illeszt), a
 *  `category` a NÉZET-preset, a `from`/`to` a dátum-tartomány (YYYY-MM-DD). Rendezés NINCS: a feed fix
 *  `occurredAt DESC` (keyset-cursor). */
export interface ActivityLogListFilters {
  q: string;
  from: string;
  to: string;
  category: string;
}

/** Query-kulcs gyár — a lista-cache egységes címzése. */
export const activityLogKeys = {
  all: ['activity-log'] as const,
  lists: () => ['activity-log', 'list'] as const,
  list: (filters: ActivityLogListFilters) => ['activity-log', 'list', filters] as const,
};
